import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fpfqb8hgs8: FaireBrandEntity = {
  token: "b_fpfqb8hgs8",
  type: "brand",
  name: "Hopes Unlimited",
  avatarUrl:
    "https://cdn.faire.com/fastly/6adc0c2ee8e95da1dabc032836465a1e3b305f6cc80b8e969e463dde20a9fbd3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1299725cfc50e3330b227791ae653722de1b157788883de6232f84921667289f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6adc0c2ee8e95da1dabc032836465a1e3b305f6cc80b8e969e463dde20a9fbd3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1299725cfc50e3330b227791ae653722de1b157788883de6232f84921667289f.png",
  location: "ROCHESTER, NY, USA",
  minimumOrderDollars: 118,
  rating: 4.9,
  reviewCount: 86,
  isInsider: true,
  description:
    "Be Fair, Buy Fair.\n\nOur vision is to engage in fair trade practices for a sustainable and kind environment.\n\nWe partner with fair trade organizations ensure safe working conditions, reasonable work hours, fair wages, gender equity, invest in development and growth of artisans and their families.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:33.337Z",
    importedBy: "entity-db-cli",
  },
};
